import { COLUMN_CONFIG } from './constant';
import {
  formatDeliveryWindow,
  isValidTimeValue,
  formatDateTime
} from '@dataGrid/gridUtilities';

const SAIADeliveryWindowGetter = ({ data }) => {
  return data.shipmentCTA || data.deliveryWindow?.join(',');
};

const getAPTWindowConfig = (columnConfig) => {
  if (columnConfig === COLUMN_CONFIG.SAIA) {
    return {
      headerName: 'Delivery Window',
      headerTooltip: 'Delivery Window',
      valueGetter: SAIADeliveryWindowGetter,
      valueFormatter: formatDeliveryWindow
    };
  }
  return {
    headerName: 'APT Window',
    headerTooltip: 'Appointment Window',
    valueGetter: (params) => params.data.shipmentCTA,
    valueFormatter: (params) => {
      if (!isValidTimeValue(params.value)) {
        return;
      }
      return params.value;
    }
  };
};

const ibEtaValueFormatter = (params) => {
  return formatDateTime(params);
};

const getRelatedEquipmentFields = (field, enableFixedEquipmentSize) => {
  if (!enableFixedEquipmentSize) {
    return field === 'maxFeasibleTrailerLength'
      ? ['minEquipmentSize']
      : ['maxFeasibleTrailerLength'];
  }
  switch (field) {
    case 'maxFeasibleTrailerLength':
      return ['minEquipmentSize', 'fixedEquipmentSize'];
    case 'minEquipmentSize':
      return ['maxFeasibleTrailerLength', 'fixedEquipmentSize'];
    default:
      return ['minEquipmentSize', 'maxFeasibleTrailerLength'];
  }
};

const isEquipmentSizeField = (field) => {
  return ['minEquipmentSize', 'maxFeasibleTrailerLength', 'fixedEquipmentSize'].includes(field);
}

const getCustomerName = (params) => {
  return params.data.isDelivery
    ? params.data.displayCustomerName
    : params.data.shipperName;
}

const getCustomerAddress = (params) => {
  return params.data.isDelivery ? getConsigneeAddress(params) : getShipperAddress(params);
}

const getConsigneeAddress = (params) => {
  return [params.data.consigneeAddress, params.data.consigneeAddress2].filter(Boolean).join(', ');
}

const getShipperAddress = (params) => {
  return [params.data.shipperAddress, params.data.shipperAddress2].filter(Boolean).join(', ');
}

const getCustomerCity = (params) => {
  return params.data.isDelivery
    ? params.data.city
    : params.data.shipperCity;
}

export {
  getAPTWindowConfig,
  ibEtaValueFormatter,
  SAIADeliveryWindowGetter,
  getRelatedEquipmentFields,
  getCustomerName,
  getCustomerAddress,
  getCustomerCity,
  isEquipmentSizeField,
  getConsigneeAddress,
  getShipperAddress,
};
